import { Injectable, ErrorHandler, Inject } from '@angular/core';

import { LoggerService } from './logger.service';
import { NewRelicService } from './new-relic.service';
import { IpAddressService } from './ip-address.service';
import { LoggerParamsTransformer, PARAM_TRANSFORMERS } from '../models';
import { LogLevel } from './logger-config';
import { LoggingEnvironment, LoggingEnvironmentConfig } from '../logging-environment.provider';
import { MegaBeaconService } from '../logger/mega-beacon.service';

/**
 * Logger specifically designed to handle Angular Errors
 * See: https://discuss.newrelic.com/t/how-to-monitor-angular-5-application/53309/2
 * @export
 * @class ErrorHandlerService
 * @extends {LoggerService}
 * @implements {ErrorHandler}
 */
@Injectable()
export class ErrorHandlerService extends LoggerService implements ErrorHandler {
  /**
   * Creates an instance of ErrorHandlerService.
   * @param {NewRelicService} newRelicService
   * @param {LoggerParamsTransformer[]>} paramTransformers
   * @memberof ErrorHandlerService
   */
  constructor(
    newRelicService: NewRelicService,
    @Inject(PARAM_TRANSFORMERS) paramTransformers: LoggerParamsTransformer[],
    ipService: IpAddressService,
    @Inject(LoggingEnvironment) environment: LoggingEnvironmentConfig,
    megaBeaconService: MegaBeaconService
  ) {
    super(newRelicService, paramTransformers, ipService, environment, megaBeaconService);
    this.caller = 'ErrorHandler';
  }

  /**
   * Handles an error
   * When the type is Error, locally log the complete error, so we see stacktrace
   * @param {*} error
   * @memberof ErrorHandlerService
   */
  public handleError(error: any) {
    if (typeof error === 'string') {
      this.error(error as string);
    } else if (error instanceof Error) {
      this.localLog(LogLevel.ERROR, undefined, error);
      this.serverLog(LogLevel.ERROR, error.message, this.updateParams());
    } else {
      this.error('ErrorHandler', error);
    }
  }
}
